<template>
	<dms-edit-layout v-bind="layoutProps">
		<dms-row>
				<dms-card row header-localization-key="Zakladni_Informace">
						<dms-col :md="6" :sm="12" :xs="24">
							<dms-input  :value.sync="KodKorekce" label-key="KOD_KOREKCE" />
						</dms-col>
						<dms-col :md="6" :sm="12" :xs="24">
							<dms-select  :select-list="dropdownList.ZakazkakorekcePzn" :value.sync="ZakazkakorekcePzn" label-key="ZAKAZKAKOREKCE_PZN" />
						</dms-col>

						<dms-col :md="6" :sm="12" :xs="24">
							<dms-select  :select-list="dropdownList.ProvozovnaId" :value.sync="ProvozovnaId" :disabled="!isCreateMode" label-key="PROVOZOVNA_ID" />
						</dms-col>

						<dms-col :md="6" :sm="12" :xs="24">
							<dms-input-number :value.sync="Oc" label-key="OC" />
						</dms-col>

						<dms-col :md="6" :sm="12" :xs="24">
							<dms-input  :value.sync="Text" label-key="TEXT" />
						</dms-col>

						<dms-col :md="6" :sm="12" :xs="24">
							<dms-check  :value.sync="UniqCheckPrp" label-key="UNIQ_CHECK_PRP" class="mt-10" />
						</dms-col>

						<dms-col :lg="12" :md="24">
							<dms-input  :value.sync="Poznamka" type="textarea" label-key="POZNAMKA" />
						</dms-col>
						<dms-col :md="6" :sm="12" :xs="24">
							<dms-input  :value.sync="VstupPracIdText" disabled label-key="VSTUP_PRAC_ID" />
						</dms-col>
						<dms-col :md="6" :sm="12" :xs="24">
							<dms-date-picker  :value.sync="VstupDat" disabled type="datetime" label-key="VSTUP_DAT" />
						</dms-col>
						<dms-col :md="6" :sm="12" :xs="24">
							<dms-input  :value.sync="EditPracIdText" disabled label-key="EDIT_PRAC_ID" />
						</dms-col>
						<dms-col :md="6" :sm="12" :xs="24">
							<dms-date-picker  :value.sync="EditDat" disabled type="datetime" label-key="EDIT_DAT" />
						</dms-col>
				</dms-card>
		</dms-row>
	</dms-edit-layout>
</template>

<script>
import { editFactory } from '@/main/pages';

import { store } from './store/edit';
import { NAME } from './constants';

export default editFactory(NAME, store);
</script>
